var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMln(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0B1529"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85269 11.3197L7.81819 13.059V14.0316L3.9375 11.7478V5.79094L9 2.8125L14.0625 5.79094V11.7478L10.1818 14.0316V13.0584L13.1467 11.3197L12.3817 10.8776L12.4819 10.7038L13.2373 11.1403V6.72356L9.40106 8.99719V15.4997L9 15.75L8.59838 15.4997V8.99719L4.76269 6.72356V11.1398L5.51756 10.7038L5.61769 10.8782L4.85269 11.3197ZM8.88863 3.83288L5.16375 6.01819L9 8.29237L12.8363 6.01819L9.08944 3.81994V4.72219H8.88863V3.83288ZM8.88863 5.29087H9.08944V6.22294H8.88863V5.29087ZM8.88863 6.79163H9.08944V7.72369L8.98875 7.76925L8.88863 7.72425V6.79163ZM12.0161 10.4198L11.916 10.5941L11.1082 10.1272L11.2089 9.95344L12.0161 10.4198ZM10.7421 9.66938L10.6414 9.84375L9.83419 9.37687L9.84544 9.26775L9.93431 9.20362L10.7421 9.66938ZM5.98331 10.4198L6.7905 9.95344L6.89119 10.1278L6.084 10.5936L5.98331 10.4198ZM7.25794 9.66938L8.06512 9.20362L8.15513 9.26775L8.16525 9.37744L7.35806 9.84319L7.25794 9.66938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMln);
export default __webpack_public_path__ + "static/media/mln.8f2c4cee77f2fe2bd10cb392c524484c.svg";
export { ForwardRef as ReactComponent };